import Cookies from 'js-cookie'

// save the token and user into the Cookies and expired in 1 day
// const tomorrow = new Date();
// tomorrow.setDate(today.getDate() + 1);

// setUserSession(getData?.tokens?.access?.token, getData?.user, getData?.tokens?.refresh?.token, getData.foodTokens.access.token, getData?.foodTokens?.refresh?.token)
 
export const setUserSession = (token, user, reFreshToken, foodToken, foodRefreshToken) => {

    Cookies.set('user', JSON.stringify(user));
    Cookies.set('coinsToken', JSON.stringify(token), { expires: 1 })
    // Cookies.set('reFreshToken', JSON.stringify(reFreshToken))
    const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
    Cookies.set('reFreshToken', JSON.stringify(reFreshToken), { expires: new Date(Date.now() + oneWeekInMilliseconds) });

    Cookies.set('foodToken', JSON.stringify(foodToken), { expires: 1 })
    // Cookies.set('reFreshToken', JSON.stringify(reFreshToken))
    Cookies.set('foodRefreshToken', JSON.stringify(foodRefreshToken), { expires: new Date(Date.now() + oneWeekInMilliseconds) });
}

export const getToken = () => {
    const token = Cookies.get('coinsToken')
    if (token) return JSON.parse(token)
    return null;
}

export const getFoodToken = () => {
    const token = Cookies.get('foodToken');

    if (!token) return null; 
    try {
        return JSON.parse(token); 
    } catch (error) {
        console.error("Invalid JSON in foodToken:", error)
        return null; 
    }
};

export const getReFreshToken = () => {
    const reFreshToken = Cookies.get('reFreshToken')
    if (reFreshToken) return JSON.parse(reFreshToken)
    return null
}

// remove the token and user from the Cookies
export const removeUserSession = () => {
    Cookies.remove('coinsToken')
    Cookies.remove('user')
    Cookies.remove('reFreshToken')
    Cookies.remove('foodToken')
}

// update user session
// export const updateUserSession = (user) => {
//     Cookies.remove('user')
//     Cookies.set('user', JSON.stringify(user), { expires: 7 })
// }

// return the user data from the Cookies
export const getUser = () => {
    const userStr = Cookies.get('user')
    if (userStr) return JSON.parse(userStr)
    return null
}

// return the token from the Cookies
// export const getToken = () =>  Cookies.get('token') || null;

// here we re storing re fresh token in place of token
export const updateUserSession = (reFreshToken) => {
    Cookies.set('token', JSON.stringify(reFreshToken))
}

// save the temporary token into the Cookies and expired in 7 days
export const setTemporarySession = (token) => {
    Cookies.set('temporary_session', JSON.stringify(token), { expires: 7 })
}

// return the token from the Cookies
export const getTemporarySession = () => {
    const TemporaryStr = Cookies.get('temporary_session')
    if (TemporaryStr) return JSON.parse(TemporaryStr)
    return null
}

// remove the temporary token
export const removeTemporarySession = () => {
    Cookies.remove('temporary_session')
}